import { render, staticRenderFns } from "./OrgaoIndex.vue?vue&type=template&id=e71a635a&"
import script from "./OrgaoIndex.vue?vue&type=script&lang=js&"
export * from "./OrgaoIndex.vue?vue&type=script&lang=js&"
import style0 from "./OrgaoIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports